module.exports = __webpack_public_path__ + "img/kirchenmaler1.4614f9e5.jpg";